module.exports = __webpack_public_path__ + "img/XFGL_en.f930068a.jpg";